import React from 'react';
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import i18n from 'i18next';
import { Button } from '@mui/material';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import api from '../../api';

@inject('commonStore', 'userStore')
@observer
class DasAuth extends Component {
  async componentDidMount() {
    const { userStore } = this.props;

    const location = window.location;
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    // 세션스토리지에 저장된 das 정보 조회
    await userStore.setDasDataFromSessionStorage();

    // das 로그인 후 돌아왔을 때의 액션
    if (code !== null && code !== undefined) {
      const redirect_uri = `${location.protocol}//${location.host}${
        location.host === 'localhost:3000' || location.host === 'dev.upsolution.co.kr:8200' ? '' : '/'
      }`;

      // 앱이 두 번 로딩 되는데 두 번째 로딩을 알 수 있는 방법이 없음. sessionStorage, 전역변수, mobX 등등을 통해 시도해 봤으나 실패
      const result = await api.getDasAccessToken(code, '', redirect_uri);

      if (result) {
        const dasRequestUrl = userStore.dasRequestUrl;
        userStore.dasToken = result.data;
        userStore.dasRequestDateTime = moment();
        userStore.dasRequestUrl = '';
        userStore.saveDasData();

        userStore.isDasLogIn = true;

        if (dasRequestUrl !== null && dasRequestUrl.length > 0) {
          this.props.history.push(dasRequestUrl);
        } else {
          this.props.history.push('/');
        }
      }
    } else {
      // 엑세스토큰을 요청한 가장 마지막 시간과의 차이
      const refreshTokenElapsedTime = moment().diff(this.props.userStore.dasRequestDateTime, 'minutes');

      // das 로그인이 되어 있을때의 액션
      if (Object.keys(userStore.dasToken).length > 0 && refreshTokenElapsedTime < 60) {
        // 로그인한지 60분이 지나면 로그아웃. 단, 결제 등으로 refresh_token 을 재발급 받았을 경우는 그 때부터 다시 계산 됨.
        if (refreshTokenElapsedTime > 60) {
          userStore.dasLogOut();
        } else {
          const remainingTime = (60 - refreshTokenElapsedTime) * 60 * 1000; // 남은 시간을 밀리초로 변환
          setTimeout(() => {
            userStore.dasLogOut();
          }, remainingTime);

          userStore.isDasLogIn = true;
        }
      } else {
        userStore.isDasLogIn = false;
      }
    }
  }

  handleDASLogIn = () => {
    const { userStore } = this.props;

    const location = window.location;
    const redirect_uri = `${location.protocol}//${location.host}${
      location.host === 'localhost:3000' || location.host === 'dev.upsolution.co.kr:8200' ? '' : '/'
    }`;

    // 현재의 url 저장
    userStore.dasRequestUrl = location.pathname;
    userStore.dasRequestDateTime = moment();
    userStore.saveDasData();

    // login
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: process.env.REACT_APP_DAS_CLIENT_ID,
      state: 'o7pvXoRj16mB7xGjOwFpXIj4jwoiDrWiB',
      redirect_uri: redirect_uri,
      scope: 'openid offline_access name email phone baystars das:pay require_address',
      // code_challenge: 'E9Melhoa2OwvFrEMTJguCHaoeK1t8URWbuGJSstw-cM',
      // code_challenge_method: 'S256',
    });

    window.location.href = `${process.env.REACT_APP_DAS_URL}/oauth2/auth?${params.toString()}`;
  };

  /** 로그아웃 설정 */
  handleDasLogOut = () => {
    const { userStore } = this.props;

    // das 로그아웃 처리
    userStore.dasLogOut();

    const location = window.location;
    const redirect_uri = `${location.protocol}//${location.host}${
      location.host === 'localhost:3000' || location.host === 'dev.upsolution.co.kr:8200' ? '' : '/'
    }`;

    // das logout
    const params = new URLSearchParams({
      client_id: process.env.REACT_APP_DAS_CLIENT_ID,
      post_logout_redirect_uri: redirect_uri,
    });
    window.location.href = `${process.env.REACT_APP_DAS_URL}/logout/rp?${params.toString()}`;
  };

  handleShowHideDialog = () => {
    this.props.commonStore.showHideDasDialog();
  };

  handleCloseClick = () => {
    const { commonStore, history } = this.props;

    if (commonStore.dasDialogGuestAction === 'close') {
      commonStore.showHideDasDialog();
    } else {
      history.push({
        pathname: `/${commonStore.companyId}/${commonStore.storeCode}/${commonStore.dasDialogGuestAction}`,
        state: { isLiff: true },
      });
      commonStore.showHideDasDialog();
    }
  };

  render() {
    const { commonStore, userStore } = this.props;
    return (
      <React.Fragment>
        {/** 로그인 / 로그아웃 버튼 */}
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={this.handleShowHideDialog}
          className="fonts-noto-sans-jp"
        >
          {i18n.t(userStore.isDasLogIn ? 'BUTTON_LOGOUT' : 'BUTTON_LOGIN')}
        </Button>

        <Dialog open={commonStore.isShowDasDialog} onClose={this.handleShowHideDialog} fullWidth maxWidth="xl">
          <div className="fonts-noto-sans-jp" style={{ padding: '15px', textAlign: 'center' }}>
            {userStore.isDasLogIn ? (
              <React.Fragment>
                <p style={{ fontWeight: 'bold', marginBottom: '25px' }}>ログアウト</p>
                <p>ログアウトすると、ログイン時のサービスが利用できなくなり、ゲスト購入となります</p>
                <div style={{ marginBottom: '25px' }}>
                  <Button
                    color={'primary'}
                    variant="contained"
                    onClick={this.handleDasLogOut}
                    className="fonts-noto-sans-jp"
                  >
                    {i18n.t('BUTTON_LOGOUT')}
                  </Button>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p style={{ fontWeight: 'bold', marginBottom: '25px' }}>DeNAアカウントでログイン</p>
                <p>
                  DeNAアカウントをお持ちの方は、ログインして購入できます。ログインすると、各種情報の入力を省略できます
                </p>

                <div style={{ marginBottom: '25px' }}>
                  <Button
                    color={'primary'}
                    variant="contained"
                    onClick={this.handleDASLogIn}
                    className="fonts-noto-sans-jp"
                  >
                    {i18n.t('BUTTON_LOGIN_JOIN_MEMBERSHIP')}
                  </Button>
                </div>

                <div style={{ borderBottom: '1px solid #171717' }}>
                  <a
                    href="https://support.accounts.dena.com/hc/ja/articles/34197857149721-DeNA%E3%82%A2%E3%82%AB%E3%82%A6%E3%83%B3%E3%83%88%E3%81%A8%E3%81%AF"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {i18n.t('MESSAGE_DENA_ACCOUNT')}
                  </a>
                </div>
                <div style={{ marginBottom: '25px', paddingTop: '15px' }}>
                  <Button color={'primary'} variant="contained" onClick={this.handleCloseClick}>
                    {i18n.t('BUTTON_BUY_GUEST')}
                  </Button>
                </div>
              </React.Fragment>
            )}
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withRouter(DasAuth);
